"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToggleContainer = exports.TerrainContainer = exports.SwitchLabel = exports.SwitchInput = exports.Slider = exports.SelectContainer = exports.Select = exports.Label = exports.ControlPanelContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const chevronDown_svg_1 = __importDefault(require("../../../../assets/icons/chevronDown.svg"));
const colors_1 = require("../../../../assets/styles/colors");
const media_1 = require("../../../../utils/media");
const ControlPanelContainer = styled_components_1.default.div `
  background: ${colors_1.white};
  cursor: auto;
  display: flex;
  font-size: 1.2rem;
  text-align: center;
  box-shadow: 2px 2px 4px 0px rgba(76, 86, 96, 0.1);
  border-radius: 5px;
  gap: 0.4rem;
  padding: 0.4rem 0.5rem;
  @media ${media_1.media.smallDesktop} {
    font-size: 1.5rem;
    gap: 1rem;
    box-shadow: 2px 2px 4px 0px rgba(76, 86, 96, 0.1);
    padding: 0;
    border-radius: 1rem;
  }
`;
exports.ControlPanelContainer = ControlPanelContainer;
const ToggleContainer = styled_components_1.default.div `
  display: none;
  @media ${media_1.media.smallDesktop} {
    display: flex;
    align-items: center;
    font-size: 1.4rem;
    padding: 1.5rem 1rem;
    height: 4.2rem;
  }
`;
exports.ToggleContainer = ToggleContainer;
const SwitchLabel = styled_components_1.default.label `
  position: relative;
  display: inline-block;
  width: 36px;
  height: 18px;
`;
exports.SwitchLabel = SwitchLabel;
const SwitchInput = styled_components_1.default.input `
  opacity: 0;
  width: 36px;
  height: 18px;
  z-index: 2;
  position: relative;

  &:checked + span:before {
    transform: translateX(17px);
  }
`;
exports.SwitchInput = SwitchInput;
const Slider = styled_components_1.default.span `
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${colors_1.blue};
  transition: 0.4s;
  border-radius: 30px;
  z-index: 1;

  &:before {
    position: absolute;
    content: "";
    height: 14px;
    width: 14px;
    left: 2.5px;
    bottom: 2px;
    padding: 0.7rem 0;
    background-color: ${colors_1.white};
    transition: 0.4s;
    border-radius: 50%;
  }
`;
exports.Slider = Slider;
const Label = styled_components_1.default.span `
  color: ${(props) => (props.$isActive ? colors_1.acBlueDark : colors_1.gray400)};
  margin: 0 1rem;
  display: flex;
  align-items: center;
  gap: 1rem;
`;
exports.Label = Label;
const TerrainContainer = styled_components_1.default.div `
  display: none;
  @media ${media_1.media.smallDesktop} {
    display: flex;
    align-items: center;
    font-size: 1.4rem;
    position: relative;
    border-left: 1px solid ${colors_1.gray200};
    padding: 0 1.6rem;
  }
`;
exports.TerrainContainer = TerrainContainer;
const SelectContainer = styled_components_1.default.div `
  display: flex;

  @media ${media_1.media.smallDesktop} {
    display: none;
  }
`;
exports.SelectContainer = SelectContainer;
const Select = styled_components_1.default.select `
  background-color: ${colors_1.white};
  border: none;
  outline: none;
  color: ${colors_1.gray400};
  padding: 0 1.2rem 0 0.5rem;
  font-size: 1.4rem;

  background: transparent;
  background-image: url(${chevronDown_svg_1.default});
  background-repeat: no-repeat;
  background-position-x: 100%;
  background-position-y: 5px;

  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
`;
exports.Select = Select;
